import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'

import { Button } from '@independent-software/typeui/controls/Button'
import { Icon } from '@independent-software/typeui/controls/Icon'
import { Panel } from '@independent-software/typeui/controls/Panel'
import { Label } from '@independent-software/typeui/controls/Label'
import { List } from '@independent-software/typeui/controls/List'

type TExportFormats = 'png' | 'jpg' | 'svg';

interface IExportProps {
  /** @ignore */
  className?: string;
  /** Is export button disabled? */
  disabled?: boolean;
  /** Callback called when an export option is clicked. */
  onExport: (format: TExportFormats) => void;
}

const ExportBase = (props: IExportProps) => {
  const [open, setOpen] = React.useState(false); // Panel currently open?

  // Toggle panel.
  const handleIconClick = () => setOpen(!open);

  // Close panel.
  const handleClose = () => setOpen(false);

  // An export option was selected. Inform the parent.
  const handleExport = (format: TExportFormats) => {
    setOpen(false);
    props.onExport(format);
  }

  return (
    <div className={props.className}>
      <span>
        <Button disabled={props.disabled} secondary size='tiny' onClick={handleIconClick}>
          <Label color="#000"><Icon color="#fff" name='file-download'/></Label>
          Export
        </Button>
        <Panel open={open} onClose={handleClose} width={280}>
          <List animated divided selection relaxed align="center">
            <List.Item onClick={() => handleExport('png')}>
              <List.Content>
                <List.Header>PNG</List.Header>
                <List.Description>Export to PNG</List.Description>
              </List.Content>
            </List.Item>
            <List.Item onClick={() => handleExport('jpg')}>
              <List.Content>
                <List.Header>JPG</List.Header>
                <List.Description>Export to JPG</List.Description>
              </List.Content>
            </List.Item>
            <List.Item onClick={() => handleExport('svg')}>
              <List.Content>
                <List.Header>SVG</List.Header>
                <List.Description>Export to SVG</List.Description>
              </List.Content>
            </List.Item>                        
          </List>
        </Panel>
      </span>
    </div>
  )
}

const Export = styled(ExportBase)`
  &>span {
    text-align: left;
  }
`

export { Export, TExportFormats }
